export const oilAndGasEngineeringConst = {
  path: "/single-programs/oil-and-gas-engineering",
  title: "ЭНЕРГЕТИЧЕСКИЙ ФАКУЛЬТЕТ – НЕФТЕГАЗОВОЕ ДЕЛО",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Нефтегазовое дело — стратегическая профессия для глобальной энергетики</h2>
      <p>
        Программа готовит специалистов для одного из ключевых секторов мировой экономики — нефтегазовой отрасли. Студенты получают
        комплексные знания о разведке, бурении, добыче, транспортировке и переработке нефти и газа. Особое внимание уделяется современным
        технологиям, автоматизации процессов и экологической безопасности.
      </p>
      <p>Образование сочетает инженерные дисциплины, прикладную геологию, химию и управление производственными циклами.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Геология и геофизика нефтегазоносных бассейнов</li>
        <li>Технология бурения и заканчивания скважин</li>
        <li>Оборудование для добычи нефти и газа</li>
        <li>Системы транспортировки: трубопроводы, компрессорные станции</li>
        <li>Переработка и утилизация углеводородов</li>
        <li>Химия нефти и газа</li>
        <li>Безопасность и охрана труда в нефтегазовой отрасли</li>
        <li>Экологический менеджмент и стандарты ЕС</li>
      </ul>
      <p>
        Программа включает лабораторные практикумы, виртуальное моделирование месторождений, изучение кейсов крупнейших компаний и
        стажировки в энергетических предприятиях.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Инженер-буровик</li>
        <li>Специалист по добыче и эксплуатации скважин</li>
        <li>Инженер по транспортировке и хранению газа и нефти</li>
        <li>Технолог перерабатывающего предприятия</li>
        <li>Проектировщик трубопроводных систем</li>
        <li>Специалист по экологической безопасности в энергетике</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€60,000 до €110,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, открывающий доступ к международной карьере</li>
        <li>Возможность обучения на русском или английском языке</li>
        <li>Дистанционный и очный форматы на выбор</li>
        <li>Преподаватели — специалисты с опытом в отрасли</li>
        <li>Стажировки и практика в нефтегазовых компаниях Европы</li>
        <li>Помощь при поступлении и трудоустройстве после выпуска</li>
      </ul>
      <p>Энергетика требует высококлассных специалистов — мы их готовим</p>
      <p>
        Наши выпускники работают в транснациональных компаниях, на месторождениях, в инжиниринговых и экологических организациях. Они
        проектируют безопасные и эффективные системы добычи и переработки ресурсов.
      </p>
      <br />
      <p className="padding-left">
        «Нефтегазовая отрасль — это вызов, технологии и ответственность. Мы учим принимать этот вызов профессионально.»
      </p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия сопровождает вас на каждом шаге: от выбора направления до подачи заявки.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Нефтегазовое дело — стратегическая профессия для глобальной энергетики
    Программа готовит специалистов для одного из ключевых секторов мировой экономики — нефтегазовой отрасли. Студенты получают комплексные знания о разведке, бурении, добыче, транспортировке и переработке нефти и газа. Особое внимание уделяется современным технологиям, автоматизации процессов и экологической безопасности.
    Образование сочетает инженерные дисциплины, прикладную геологию, химию и управление производственными циклами.
    Что вы будете изучать?
    • Геология и геофизика нефтегазоносных бассейнов
    • Технология бурения и заканчивания скважин
    • Оборудование для добычи нефти и газа
    • Системы транспортировки: трубопроводы, компрессорные станции
    • Переработка и утилизация углеводородов
    • Химия нефти и газа
    • Безопасность и охрана труда в нефтегазовой отрасли
    • Экологический менеджмент и стандарты ЕС
    Программа включает лабораторные практикумы, виртуальное моделирование месторождений, изучение кейсов крупнейших компаний и стажировки в энергетических предприятиях.
    Кем можно работать после окончания?
    • Инженер-буровик
    • Специалист по добыче и эксплуатации скважин
    • Инженер по транспортировке и хранению газа и нефти
    • Технолог перерабатывающего предприятия
    • Проектировщик трубопроводных систем
    • Специалист по экологической безопасности в энергетике
    Зарплата в Европе: от €60,000 до €110,000 в год
    Почему выбирают нас?
    • Европейский диплом, открывающий доступ к международной карьере
    • Возможность обучения на русском или английском языке
    • Дистанционный и очный форматы на выбор
    • Преподаватели — специалисты с опытом в отрасли
    • Стажировки и практика в нефтегазовых компаниях Европы
    • Помощь при поступлении и трудоустройстве после выпуска
    Энергетика требует высококлассных специалистов — мы их готовим
    Наши выпускники работают в транснациональных компаниях, на месторождениях, в инжиниринговых и экологических организациях. Они проектируют безопасные и эффективные системы добычи и переработки ресурсов.
    «Нефтегазовая отрасль — это вызов, технологии и ответственность. Мы учим принимать этот вызов профессионально.»

    Как поступить?
    Приёмная комиссия сопровождает вас на каждом шаге: от выбора направления до подачи заявки.
  `,
};
